export default __webpack_public_path__ + "static/capgemini-1efd1b6a9cefe41017dc81dc7ce74888.svg";